import { FileText, Image as ImageIcon, File, X } from "lucide-react";
import { http } from "@/lib/api";

const fmt = (n) => (n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);

export function FileCard({ file, onRemove }) {
  const Icon = file.is_image ? ImageIcon : ["pdf", "docx", "txt", "md"].includes(file.ext) ? FileText : File;
  const open = async () => {
    if (onRemove) return;
    const r = await http.get(`/files/${file.file_id}`, { responseType: "blob" });
    window.open(URL.createObjectURL(r.data), "_blank");
  };
  return (
    <div onClick={open} data-testid={`file-card-${file.file_id}`}
      className={`inline-flex items-center gap-2.5 pl-2.5 pr-3 py-2 rounded-xl border border-white/10 bg-white/[0.04] max-w-[240px] ${onRemove ? "" : "cursor-pointer hover:bg-white/[0.08]"} transition-colors`}>
      <div className="h-8 w-8 rounded-lg bg-sky-400/10 text-sky-300 flex items-center justify-center shrink-0">
        <Icon className="h-4 w-4" />
      </div>
      <div className="min-w-0">
        <p className="text-xs text-neutral-200 truncate">{file.filename}</p>
        <p className="text-[10px] text-neutral-500 uppercase">{file.ext} · {fmt(file.size)}</p>
      </div>
      {onRemove && (
        <button onClick={onRemove} className="text-neutral-500 hover:text-white ml-1" data-testid={`file-remove-${file.file_id}`}>
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
